import type { ReactNode } from 'react';
import * as Sentry from '@sentry/react';
import { Paper, Stack, Text, Title } from '@mantine/core';

function AppErrorFallback() {
  return (
    <Paper withBorder radius="md" p="xl" maw={520} mx="auto" mt="xl">
      <Stack gap="md">
        <Title order={2}>Ein unerwarteter Fehler ist aufgetreten.</Title>
        <Text c="dimmed">
          Der Fehler wurde erfasst. Bitte lade die Seite neu oder versuche den letzten Schritt erneut.
        </Text>
      </Stack>
    </Paper>
  );
}

export function AppErrorBoundary({ children }: { children: ReactNode }) {
  return (
    <Sentry.ErrorBoundary fallback={<AppErrorFallback />}>
      {children}
    </Sentry.ErrorBoundary>
  );
}
